import React from 'react';
import Loadable from 'react-loadable';
import Loader from 'desktop/components/Common/BlankLoader.js';

const ForgotPasswordLoadable = Loadable({
    loader: () => import('desktop/containers/ForgotPassword/ForgotPassword.js' /* webpackChunkName: 'forgotPassword' */).then(module => module.default),
    loading: () => <Loader />
});

export default ForgotPasswordLoadable;
